import AuthReducer from './AuthSlice'
import CommonReducer from './CommonSlice'
import CategoryReducer from './CategorySlice'
import CategoryIpdReducer from './CategoryIpdSlice'
import DialogReducer from './DialogSlice'
import TherapyRoomReducer from './TherapyRoomSlice'
import IDProofReducer from './IDProofSlice'
import ReferenceReducer from './ReferenceSlice'
import InquiryTypeReducer from './InquiryTypeSlice'
import ExpenditureSubjectReducer from './ExpenditureSubjectSlice'
import ConsultationDepartmentReducer from './ConsultationDepartmentSlice'
import SalonCategoryReducer from './SalonCategorySlice'
import LanguageReducer from './LanguageSlice'
import DietItemReducer from './DietItemSlice'
import DiseaseReducer from './DiseaseSlice'
import SalonReducer from './SalonSlice'
import GSTReducer from './GSTSlice'
import InvestigationReducer from './InvestigationSlice'
import ExtraChargeSubjectReducer from './ExtraChargeSubjectSlice'
import PersonTypeReducer from './PersonTypeSlice'
import LaundryPriceReducer from './LaundryPriceSlice'
import TherapyReducer from './TherapySlice'
import DepartmentReducer from './DepartmentSlice'
import OTChargeReducer from './OTChargeSlice'
import SupplierReducer from './SupplierSlice'
import MedicineReducer from './MedicineSlice'
import MedicinetypeReducer from './MedicinetypeSlice'

const Reducers = {
    AuthReducer,
    CommonReducer,
    CategoryReducer,
    DialogReducer,
    CategoryIpdReducer,
    TherapyRoomReducer,
    IDProofReducer,
    ReferenceReducer,
    InquiryTypeReducer,
    ExpenditureSubjectReducer,
    ConsultationDepartmentReducer,
    SalonCategoryReducer,
    LanguageReducer,
    DietItemReducer,
    DiseaseReducer,
    SalonReducer,
    GSTReducer,
    InvestigationReducer,
    ExtraChargeSubjectReducer,
    PersonTypeReducer,
    LaundryPriceReducer,
    TherapyReducer,
    DepartmentReducer,
    OTChargeReducer,
    SupplierReducer,
    MedicineReducer,
    MedicinetypeReducer,
}

export default Reducers
